"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var react_1 = __importStar(require("react"));
var Cores_1 = require("../Cores/Cores");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Botao_1 = require("../Botao/Botao");
var Icone_1 = require("../Icone/Icone");
var chipModule = require("./Chip.module.scss");
var Chip = function (props) {
    var _a, _b, _c;
    var _d = (0, react_1.useState)(Cores_1.Cores.CoresIdentidadeMU.brancoMu), color = _d[0], setColor = _d[1];
    var _e = (0, react_1.useState)(Cores_1.Cores.CoresIdentidadeMU.azulMu), activeColor = _e[0], setActiveColor = _e[1];
    var chipStyle = props.desabilitado ? chipModule["desabilitado"] : chipModule[(_a = props.estilo) !== null && _a !== void 0 ? _a : 'primary_light'];
    var chipSize = chipModule[(_b = props.tamanho) !== null && _b !== void 0 ? _b : 'regular'] || "";
    var chipState = props.estado ? chipModule.active : "";
    var chipCursor = props.onClick ? chipModule.clickable : "";
    (0, react_1.useEffect)(function () {
        if (props.desabilitado) {
            setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
            setActiveColor(props.estado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU400 : Cores_1.Cores.CoresIdentidadeMU.brancoMu);
        }
        else {
            switch (props.estilo) {
                case "primary_light":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.CoresIdentidadeMU.azulMu);
                    setActiveColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.azulMu : Cores_1.Cores.CoresIdentidadeMU.brancoMu);
                    break;
                case "primary_dark":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600);
                    setActiveColor(props.estado ? Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600 : Cores_1.Cores.CoresIdentidadeMU.brancoMu);
                    break;
                case "gray":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.CoresIdentidadeMU.cinzaMu);
                    setActiveColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.cinzaMu : Cores_1.Cores.CoresIdentidadeMU.brancoMu);
                    break;
                case "success":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    setActiveColor(props.estado ? Cores_1.Cores.MensagensDoSistema.VerdeMU : Cores_1.Cores.MensagensDoSistema.VerdeFillMU);
                    break;
                case "warning":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.MensagensDoSistema.LaranjaMU);
                    setActiveColor(props.estado ? Cores_1.Cores.MensagensDoSistema.LaranjaMU : Cores_1.Cores.MensagensDoSistema.LaranjaFillMU);
                    break;
                case "info":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.MensagensDoSistema.AzulMU);
                    setActiveColor(props.estado ? Cores_1.Cores.MensagensDoSistema.AzulMU : Cores_1.Cores.MensagensDoSistema.AzulFillMU50);
                    break;
                case "error":
                    setColor(props.estado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    setActiveColor(props.estado ? Cores_1.Cores.MensagensDoSistema.VermelhoMU : Cores_1.Cores.MensagensDoSistema.VermelhoFillMU);
                    break;
            }
        }
    }, [props.estilo, props.estado, props.desabilitado]);
    var renderTexto = function (texto) {
        return (react_1.default.createElement(Corpo_1.Corpo, { cor: color, tipo: "button2", negrito: 700, style: { cursor: props.onClick ? "pointer" : "default" } }, texto));
    };
    var renderCloseButton = function () {
        return react_1.default.createElement(Botao_1.Botao, { tamanho: "xsmall", tipo: "tipoIconRound", estilo: "ghost", onClick: props.onClose ? props.onClose : undefined, style: { cursor: 'pointer' } },
            react_1.default.createElement(Icone_1.Icone, { largura: "20px", altura: "20px", nome: "close", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu }));
    };
    return (react_1.default.createElement("div", { id: props.id, style: __assign({ color: color, backgroundColor: activeColor, border: "1px solid ".concat(color) }, props.style), className: "\n                ".concat(chipModule.chip, " \n                ").concat(chipStyle, " \n                ").concat(chipSize, " \n                ").concat(chipState, "\n                ").concat(chipCursor, "\n            "), onClick: (_c = props.onClick) !== null && _c !== void 0 ? _c : undefined },
        props.icone && react_1.default.createElement(Icone_1.Icone, { nome: props.icone, cor: color }),
        typeof props.titulo === 'string' ? renderTexto(props.titulo) : props.titulo,
        props.estado && props.botaoFechar && renderCloseButton()));
};
exports.Chip = Chip;
